import { render } from "./updateSchedule.vue?vue&type=template&id=33c271a8"
import script from "./updateSchedule.vue?vue&type=script&lang=js"
export * from "./updateSchedule.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__